<div class="row">
    <div class="col-md-6">
        <div class="main-card card" style="height: 100%;">
            <div class="card-body">
                <h2 class="card-title">General info</h2>
                <div class="row">
                    <div class="col-md-3">
                        <label>Identifier:</label>
                    </div>
                    <div class="col-md-9">
                        {{ audience.id}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <label>Name:</label>
                    </div>
                    <div class="col-md-9">
                        {{ audience.name}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <label>Category:</label>
                    </div>
                    <div class="col-md-9">
                        {{ audience.category?.name}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <label>Creation date:</label>
                    </div>
                    <div class="col-md-9">
                        {{ audience.created | date }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <label>Last refresh date:</label>
                    </div>
                    <div class="col-md-9">
                        {{ audience.updated | date }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <label>Description:</label>
                    </div>
                    <div class="col-md-9">
                        {{ audience.description }}
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-6">
        <div class="main-card card" style="height: 100%;">
            <div class="card-body">
                <h2 class="card-title">Audience volume</h2>
                <div class="row">
                    <div class="col-md-4">
                        <label>Total profiles:</label>
                    </div>
                    <div class="col-md-8">
                        {{ audience.profilesCount | number:'':'es' }}
                    </div>
                </div>
                <h2 class="card-title">Profiles per identifier type</h2>
                <ng-container *ngFor="let item of getIdentifiersCountsSorted()">
                    <div class="row">
                        <div class="col-md-4 d-flex align-items-center">
                            <img [src]="audiencesService.getIdentifiersTypeSmallIcon(+item.key)" alt="icon"
                                style="width: 32px; height: 32px; margin:2px">
                            {{audiencesService.getIdGraphTypeDescription(+item.key) }}:
                        </div>
                        <div class="col-md-8 d-flex align-items-center">
                            {{ item.value | number:'':'es'}}
                        </div>
                    </div>
                    <div class="vertical-separator"></div>
                </ng-container>
            </div>
        </div>

    </div>
</div>